import produce from 'immer'

export default (state, { value, type }) => produce(state, draft => {
	switch(type) {
		case 'dateTime':
			draft.from = value.from
			draft.to = value.to
			break
		case 'datePeriod':
			draft.from = value.from
			draft.to = value.to
			break
		case 'timePeriod':
			draft.timeStart = value.from
			draft.timeEnd = value.to
			break
		default: draft[type] = value
	}
})
